import { Component, OnInit } from '@angular/core';
import { content } from '@cigna/omni/shared-util';
import { OmniConversationsFacade } from '@cigna/omni/conversations-state-data-access';
import { OmniConversationSummaryCard } from '@cigna/omni/conversation-summary-card-feature';

@Component({
  selector: 'cigna-omni-active-dms',
  templateUrl: './active-dms.component.html',
  styleUrls: ['./active-dms.component.scss'],
})
export class ActiveDMsComponent implements OnInit {
  public disclaimer = content.newDMUIDisclaimer;
  activeDMConversations$ = this.conversationsFacade.openDMConversations$;
  constructor(private conversationsFacade: OmniConversationsFacade) {}

  ngOnInit() {
    this.conversationsFacade.getActiveAsyncConversation();
  }

  public trackByFunc(index: number, item: OmniConversationSummaryCard): string {
    return item.conversationId;
  }
}
